import { useNavigate, useLocation, Link } from 'react-router-dom';
import { Row } from 'antd';
import LangSwitcher from '../langSwitcher';
import './index.less';

export default function EmptyHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname, search } = location;
  return <Row className='page-header-empty'>
    <div className='page-header-content'>
      <div className='page-header_left'>
        <Link to='/login' onClick={() => { navigate(`/login?redirect=${pathname}${search}`, { replace: true }); }}><div className='logo'></div></Link>
      </div>
      <div className='page-header_right'>
        <LangSwitcher />
      </div>
    </div>
  </Row>;
}